import type { Theme } from '@mui/material';

export const styles = {
  loadingIndicator: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  intro: (theme: Theme) => ({
    pb: 4,
    a: {
      color: theme.colors.black,
    },
  }),
};
